<!-- DASHBOARD -->
<div>
  <a class="sx-sidenav__menuitem" id="side_nav_start" [ngClass]="{'active': appRouter.url.indexOf('/secure/dashboard') === 0}" mat-menu-item
    [routerLink]="['/secure/dashboard']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-start-dashboard" href="#sx-start-dashboard" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.dashboard' | translate}}</div>
    </div>
  </a>
</div>

<!-- METERINGPOINTS -->
<div [hidden]="meteringPoints.loaded && meteringPoints.meteringPoints.length === 0">
  <a class="sx-sidenav__menuitem" id="side_nav_meteringpoints" [ngClass]="{'active': appRouter.url.indexOf('/secure/meteringpoints') === 0}"
    mat-menu-item [routerLink]="['/secure/meteringpoints']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-anlaggningar" href="#sx-anlaggningar" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.metering' | translate}}</div>
    </div>
  </a>
</div>
<div [hidden]="!meteringPoints.loaded || (meteringPoints.loaded && meteringPoints.meteringPoints.length > 0)">
  <a class="sx-sidenav__menuitem" id="side_nav_meteringpoints" mat-menu-item [disabled]="true">
    <div class="sx-sidenav__innercontent sx-sidenav__disabled">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-anlaggningar" href="#sx-anlaggningar" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.metering' | translate}}</div>
    </div>
  </a>
</div>

<!-- CONTRACTS -->
<div app-sec-trim [hidden]="meteringPoints.loaded && meteringPoints.meteringPoints.length === 0"
  [permissions]="[PermissionEnum.ViewAgreements]">
  <a class="sx-sidenav__menuitem" id="side_nav_contracts" [ngClass]="{'active': appRouter.url.indexOf('/secure/contracts') === 0}" mat-menu-item
    [routerLink]="['/secure/contracts']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-avtal" href="#sx-avtal" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.contracts' | translate}}</div>
    </div>
  </a>
</div>
<div app-sec-trim
  [hidden]="!meteringPoints.loaded || (meteringPoints.loaded && meteringPoints.meteringPoints.length > 0)"
  [permissions]="[PermissionEnum.ViewAgreements]">
  <a class="sx-sidenav__menuitem" id="side_nav_contracts" [ngClass]="{'active': appRouter.url.indexOf('/secure/contracts') === 0}" mat-menu-item
    [disabled]="true">
    <div class="sx-sidenav__innercontent  sx-sidenav__disabled">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-avtal" href="#sx-avtal" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.contracts' | translate}}</div>
    </div>
  </a>
</div>

<!-- INVOICES -->
<div [hidden]="meteringPoints.loaded && meteringPoints.meteringPoints.length === 0">
  <a class="sx-sidenav__menuitem" id="side_nav_invoices" [ngClass]="{'active': appRouter.url.indexOf('/secure/invoices') === 0}" mat-menu-item
    [routerLink]="['/secure/invoices']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-faktura" href="#sx-faktura" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.invoices' | translate}}</div>
    </div>
  </a></div>
<div [hidden]="!meteringPoints.loaded || (meteringPoints.loaded && meteringPoints.meteringPoints.length > 0)">
  <a class="sx-sidenav__menuitem" id="side_nav_invoices" [ngClass]="{'active': appRouter.url.indexOf('/secure/invoices') === 0}" mat-menu-item
    [disabled]="true">
    <div class="sx-sidenav__innercontent sx-sidenav__disabled">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-faktura" href="#sx-faktura" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.invoices' | translate}}</div>
    </div>
  </a>
</div>
<!-- services -->
<div>
  <a class="sx-sidenav__menuitem" id="side_nav_products" [ngClass]="{'active': appRouter.url.indexOf('/secure/products') === 0}" mat-menu-item
    [routerLink]="['/secure/products']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-energitjanster" href="#sx-energitjanster" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.services' | translate}}</div>
    </div>
  </a>
</div>

<!-- ANALYZE -->
<div [hidden]="meteringPoints.loaded && meteringPoints.meteringPoints.length === 0">
  <a class="sx-sidenav__menuitem" id="side_nav_analyze" [ngClass]="{'active': appRouter.url.indexOf('/secure/analyze') === 0}" mat-menu-item
    [routerLink]="['/secure/analyze']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-karriarsutveckling" href="#sx-karriarsutveckling" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.analyze' | translate}}</div>
    </div>
  </a>
</div>
<div [hidden]="!meteringPoints.loaded || (meteringPoints.loaded && meteringPoints.meteringPoints.length > 0)">
  <a class="sx-sidenav__menuitem" id="side_nav_analyze" [ngClass]="{'active': appRouter.url.indexOf('/secure/analyze') === 0}" mat-menu-item
    [disabled]="true">
    <div class="sx-sidenav__innercontent sx-sidenav__disabled">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-karriarsutveckling" href="#sx-karriarsutveckling" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.analyze' | translate}}</div>
    </div>
  </a>
</div>

<!-- ALARMS -->
<div [hidden]="meteringPoints.loaded && meteringPoints.meteringPoints.length === 0">
  <a class="sx-sidenav__menuitem" id="side_nav_alarms" [ngClass]="{'active': appRouter.url.indexOf('/secure/alarms') === 0}" mat-menu-item
    [routerLink]="['/secure/alarms']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-larm" href="#sx-larm" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.alarms' | translate}}</div>
    </div>
  </a>
</div>
<div [hidden]="!meteringPoints.loaded || (meteringPoints.loaded && meteringPoints.meteringPoints.length > 0)">
  <a class="sx-sidenav__menuitem" id="side_nav_alarms" [ngClass]="{'active': appRouter.url.indexOf('/secure/alarms') === 0}" mat-menu-item
    [disabled]="true">
    <div class="sx-sidenav__innercontent sx-sidenav__disabled">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-larm" href="#sx-larm" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.alarms' | translate}}</div>
    </div>
  </a>
</div>

<!-- ENVIRONMENT -->
<div>
  <a class="sx-sidenav__menuitem" id="side_nav_environment" [ngClass]="{'active': appRouter.url.indexOf('/secure/environment') === 0}" mat-menu-item
    [routerLink]="['/secure/environment']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-miljo" href="#sx-miljo" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.environment' | translate}}</div>
    </div>
  </a>
</div>

<!-- PERMISSIONS -->
<div app-sec-trim [userTypes]="[UserTypeEnum.Private, UserTypeEnum.Brf, UserTypeEnum.Company]">
  <a class="sx-sidenav__menuitem" id="side_nav_permissions" [ngClass]="{'active': appRouter.url.indexOf('/secure/customers') === 0}" mat-menu-item
    [routerLink]="['/secure/customers']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-behorighetsadministration" href="#sx-behorighetsadministration" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.customers' | translate}}</div>
    </div>
  </a>
</div>
<div app-sec-trim [userTypes]="[UserTypeEnum.Manager]">
  <a class="sx-sidenav__menuitem" id="side_nav_managerpermissions" [ngClass]="{'active': appRouter.url.indexOf('/secure/managers') === 0}" mat-menu-item
    [routerLink]="['/secure/managers']">
    <div class="sx-sidenav__innercontent">
      <svg class="sx-sidenav__icon">
        <use xlink:href="#sx-behorighetsadministration" href="#sx-behorighetsadministration" />
      </svg>
      <div class="sx-sidenav__text">{{'core.sidebar.managers' | translate}}</div>
    </div>
  </a>
</div>
